export default __webpack_public_path__ + "static/3-f6e7a81fcd049be5affbda423e93097c.png";